import { Component, inject, OnInit, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { APP_CONFIG_TOKEN } from "@kno2/core/config";
import { LocalStorageService, SessionStorageService } from "@kno2/core/storage";
import { DialogBodyComponent, DialogFooterComponent, DialogService } from "@kno2/shared/dialog";

@Component({
    selector: "kno2-onboarding-org-activation-delay-modal",
    imports: [FormsModule, DialogBodyComponent, DialogFooterComponent],
    templateUrl: "./onboarding-org-activation-delay-modal.component.html"
})
export class OnboardingOrgActivationDelayModalComponent implements OnInit {
    private readonly dialogService = inject(DialogService);
    private readonly localStorageService = inject(LocalStorageService);
    private readonly sessionStorageService = inject(SessionStorageService);
    private readonly appConfig = inject(APP_CONFIG_TOKEN);

    protected readonly brandDisplayName = signal(this.appConfig.brandDisplayName);

    protected hidePrompt = false;

    public ngOnInit(): void {
        this.sessionStorageService.set("hideOrgActivationDelayModal", true);
    }

    protected cancel(): void {
        this.dialogService.close(false);
    }

    protected ok(): void {
        if (this.hidePrompt) {
            this.localStorageService.set("hideOrgActivationDelayModal", this.hidePrompt);
        }

        this.dialogService.close(true);
    }
}
